import type { CmpHider } from './types';

export const cookieInformation: CmpHider = {
  id: 'cookie-information',
  label: 'Cookie Information',
  css: `
      /* Cookie Information (cookieinformation.com CMP): the consent UI mounts as
         a fixed, full-viewport backdrop "#coiOverlay" (class coi-banner-properties,
         bg rgba(0,0,0,0.7), z-index 2147483647) that both dims the page and wraps
         the banner card "#coi-banner-wrapper" (.coi-banner__wrapper) with its page
         panels "#coiPage-1"/"[id^=coiPage]" (.coi-banner__page). Hiding the overlay
         removes the dimmer and the banner in one go; we also hide the wrapper, the
         page panels, and the persistent renew/preferences pieces
         (#Coi-Renew / .coi-banner-categories / #coiConsentBannerCategoriesWrapper)
         in case a build mounts them outside the overlay or leaves a persistent
         "renew consent" control over the page. Cookie Information locks page scroll
         by adding the "noScroll" class to <html> (and via ".noScroll body"); its own
         rule ".noScroll, .noScroll body { overflow: hidden !important }" is injected
         at runtime AFTER this style, so matching its specificity plus !important
         loses on source order — we lead with "html.noScroll" / "html.noScroll body"
         (one extra type selector) to out-specify it, and clear the height clamp the
         class also sets. */
      #coiOverlay,
      #coi-banner-wrapper,
      .coi-banner__wrapper,
      [id^="coiPage"],
      .coi-banner__page,
      #coiConsentBannerCategoriesWrapper,
      .coi-banner-categories,
      #Coi-Renew { display: none !important; }
      html.noScroll,
      html.noScroll body {
        overflow: visible !important;
        position: static !important;
        height: auto !important;
      }
  `,
};
